import React from "react";
import CircularProgess from "@mui/material/CircularProgress";

import styles from "./LoadingSpinner.module.scss";

export interface LoadingSpinnerProps {
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit',
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = (
  props: LoadingSpinnerProps
) => {
  return (
    <div className={styles.loadingSpinner}>
      <CircularProgess color={props.color}/>
    </div>
  );
};
